const indexItems = [
  { title: '娱乐圈年度大瓜盘点', count: '326条', tag: '合集' },
  { title: '网红圈争议事件全记录', count: '218条', tag: '热' },
  { title: '影视剧争议话题索引', count: '187条', tag: '合集' },
  { title: '综艺节目名场面合集', count: '165条', tag: '新' },
  { title: '品牌公关翻车实录', count: '142条', tag: '合集' },
  { title: '明星恋情时间线整理', count: '128条', tag: '热' },
  { title: '音乐圈大事件汇总', count: '109条', tag: '合集' },
  { title: '体育圈八卦全纪录', count: '95条', tag: '新' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            爆料合集
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            按话题分类的专题索引，一键直达你想看的瓜
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <a
                key={item.title}
                href="#"
                className="group bg-background-50 rounded-xl p-4 md:p-5 cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-folder-line text-secondary-600"></i>
                </div>
                <div className="flex items-center gap-1.5 mb-1">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-bold whitespace-nowrap ${
                      item.tag === '热'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '新'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}